import { useFormikContext } from 'formik';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { prettyFloatMoney } from '@/helpers/utils';
import { CURRENCY } from '@/helpers/constants';
import { useGetFundraisingRecalculation } from '@/query/queries/fundraising/useGetFundraisingRecalculation';
import { FpgAssetsModal } from '@/modals/FpgAssetsModal';
import { FpgDocumentsModal } from '@/modals/FpgDocumentsModal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const FpgAssetsUpload = ({ manualTariffSet, companyId, freeFpgOption }) => {
  const { values, setFieldValue } = useFormikContext();
  const { t } = useTranslation('fundraising');

  const { data: result } = useGetFundraisingRecalculation({
    tariff: manualTariffSet ? null : values.tariff_plan?.id,
    fpg: values.fpg?.id || null,
    flexibility: values.flexibility_option?.id || null,
    new_funds: values.new_funds || null,
    company_id: companyId,
  });

  const { openSingleModal } = useModal();

  const onUpload = files => {
    setFieldValue('fpg_assets', files);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className="f-body-regular">{t('fpg_assets_upload.title')}</div>
        <div className={s.desc}>
          <Trans
            ns="fundraising"
            i18nKey="fpg_assets_upload.you_can_provide_documents"
            values={{
              amount:
                result?.goal_amount && freeFpgOption
                  ? prettyFloatMoney(result?.goal_amount * freeFpgOption.fpg_percent)
                  : `${CURRENCY}10'000`,
            }}
            components={{
              Span: <span onClick={() => openSingleModal(MODAL_IDS.fpg_docs_modal)} />,
            }}
          />
        </div>
      </div>
      <button
        type="button"
        className={classnames(r.grey_small, s.btn_upload)}
        onClick={() => openSingleModal(MODAL_IDS.fpg_assets_modal)}
      >
        {values.fpg_assets.length
          ? t('fpg_assets_upload.edit_files', {
              count: values.fpg_assets.length,
            })
          : t('fpg_assets_upload.upload_files')}
      </button>
      <FpgAssetsModal value={values.fpg_assets} onUpload={onUpload} />
      <FpgDocumentsModal />
    </div>
  );
};
